<template>
    <tr class="cart-table__row">
        <td class="cart-table__column cart-table__column--quantity" data-title="Part">
            <div class="cart-table__quantity input-number">
                <input class="form-control-order-entry-field-product" type="text" placeholder="Enter Part Number" :value="part.item"  @change.prevent="changeItemCode($event.target.value)">
            </div>
        </td>
        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
            <base-quantity-input v-model="quantity" @changedQty="changedQty(quantity)"></base-quantity-input>
            <!-- <div class="cart-table__quantity input-number">
                <input class="form-control-order-entry-qty-selector input-number__input" type="number" min="0" :value="part.quantity" data-title="Quantity">
                <div class="input-number__add"></div>
                <div class="input-number__sub"></div>
            </div> -->
        </td>
        <td class="cart-table__column cart-table__column--quantity" data-title="MFG Code">
            <div class="cart-table__quantity input-number">
                <input class="form-control-order-entry-field-mfg-code" type="text" :value="part.manufacturer" @change.prevent="changeMFGCode($event.target.value)">
            </div>
        </td>
        <td class="cart-table__column cart-table__column--product">
            
                <font :class="classStock">{{ stockStatus }}</font>
            
            <a href="#" class="cart-table__product-name"></a><br />										
            <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer"></font></div>	
            <div class="cart-table__quantity input-number">
            </div>
        </td>
        <td class="cart-table__column cart-table__column--price" data-title="Price">
            <p class="cart-table--price"><strong></strong><br>
            <strong><font class="text-danger"></font></strong>
            <br></p>
        </td>
        <td class="cart-table__column cart-table__column--total" data-title="Total"><strong></strong></td>
        <td class="cart-table__column cart-table__column--remove">
            <svg width="25" height="25" viewBox="0 0 32 32" class="cart-X-svg cart-table__remove" @click="removeItem">
                <path d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
            </svg>
        </td>
    </tr>
</template>

<script>
import Price from '../../../mixins/price.js';

export default {
    props: {
        part: {
            
        },
        locations: {
            
        },
        index: {
            type: Number
        }
    },
    data() {
        return {
            quantity: 0,
            // linetotal: 0,
        };
    },
    computed: {
        item_locations() {
            return this.locations.filter(item => (item.EIITMC === this.part.EIITMC))
        },

        linetotal() {
            return this.quantity * this.part.EIEXCP;
        },

        classStock(){
            if(this.part.isValid == 'N'){
                return 'text-currently-unavailable';
            }

            if(this.part.isValid == 'Y'){
                return 'text-available';
            }

            return '';
        },

        stockStatus(){
            if(this.part.isValid == 'N'){
                return 'INVALID';
            }

            if(this.part.isValid == 'Y'){
                return 'VALID';
            }
            
            return '';
        },

    },
    mixins: [
        Price
    ],
    methods: {
        removeItem() {
            this.$emit('remove_item', this.index);
        },
        changedQty(newQty) {
            this.quantity = newQty;
            this.$emit('update_qty', this.index, newQty);
        },

        changeItemCode(newVal){
            this.$emit('update_item_code', this.index, newVal);
        },

        changeMFGCode(newVal){
            this.$emit('update_mfg_code', this.index, newVal);
        }
    },
    created(){
    },

    updated() {
        this.quantity = this.part.quantity
    }
}
</script>